import { Box } from "@chakra-ui/react";
import { ReactComponent as MenuIcon } from "src/icons/menu.svg";
import IconAsButton from "src/components/IconAsButton";
import Dropdown from "src/components/Dropdown";

export default function Menu({
  isDisabled = false,
  disabled = false,
  onClose,
  anchorEl,
  isOpen,
  onOpen,
  children,
  icon,
  iconSize = "20px",
  iconFill = "mediumEmphasis",
  placement,
  elevationLevel = 1,
  shouldCloseOnClick = false,
  py,
  popoverProps,
  contentProps,
  anchorProps
}) {
  return (
    <Dropdown
      anchorProps={anchorProps}
      popoverProps={popoverProps}
      placement={placement}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      anchorEl={
        anchorEl ||
        (onOpen ? (
          <IconAsButton
            isDisabled={disabled || isDisabled}
            onClick={isOpen ? onClose : onOpen}
            fill={iconFill}
            icon={icon || MenuIcon}
            size={iconSize}
          />
        ) : undefined)
      }
      contentProps={{
        bg: `surfaceElevated${elevationLevel}`,
        ...contentProps
      }}
    >
      <Box
        py={py}
        onClick={(e) => {
          if (shouldCloseOnClick && isOpen) onClose();
        }}
      >
        {children}
      </Box>
    </Dropdown>
  );
}
